// src/pages/RelatorioNovo.js

import React, { useState } from "react";
import AdminLayout from "../components/AdminLayout";

function RelatorioNovo() {
  const [formData, setFormData] = useState({
    responsavelAtendimento: "",
    cargoFuncao: "",
    dataVisita: "",
    processoSIGED: "",
    objeto: "",
    valorSolicitado: "",
    responsavelFMS: "",
    nomeOSC: "",
    cnpj: "",
    endereco: "",
    cep: "",
    presidente: "",
    periodoMandato: "",
    responsavelEntidade: "",
    telefone: "",
    email: "",
    finalidadeOSC: "",
    tituloProjeto: "",
    enderecoProjeto: "",
    numeroBeneficiarios: "",
    publicoAlvo: "",
    horarioFuncionamento: "",
    diasFuncionamento: "",
    atividadeNoMomento: false,
    atividadeDescricao: "",
    atividadesDesenvolvidas: "",
    organizacaoCursos: "",
    conformidadeServico: "",
    metaAtendimento: "",
    capacidadeInstalada: "",
    corpoTecnico: "",
    captacaoRecursos: "",
    recomendacoes: "",
    conclusao: "",
    tecnicaResponsavel: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulário enviado:", formData);
  };

  return (
    <AdminLayout>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-body">
              <h3 className="card-title">Novo Relatório</h3>
              <div className="row row-cards">
                {/* Responsável pelo atendimento */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Profissional Responsável pelo Atendimento</label>
                    <input type="text" className="form-control" name="responsavelAtendimento" onChange={handleChange} value={formData.responsavelAtendimento} />
                  </div>
                </div>

                {/* Cargo / Função */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Cargo / Função</label>
                    <input type="text" className="form-control" name="cargoFuncao" onChange={handleChange} value={formData.cargoFuncao} />
                  </div>
                </div>

                {/* Data da Visita e Processo SIGED */}
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Data da Visita</label>
                    <input type="date" className="form-control" name="dataVisita" onChange={handleChange} value={formData.dataVisita} />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Processo SIGED Nº</label>
                    <input type="text" className="form-control" name="processoSIGED" onChange={handleChange} value={formData.processoSIGED} />
                  </div>
                </div>

                {/* Objeto e Valor Solicitado */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Objeto</label>
                    <input type="text" className="form-control" name="objeto" onChange={handleChange} value={formData.objeto} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Valor Solicitado</label>
                    <input type="text" className="form-control" name="valorSolicitado" onChange={handleChange} value={formData.valorSolicitado} />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Responsavel pela visita Técnica</label>
                    <input type="text" className="form-control" name="responsavelFMS" onChange={handleChange} value={formData.responsavelFMS} />
                  </div>
                </div>


                {/* Identificação */}
                <h4 className="mt-4">1. Identificação</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome da OSC</label>
                    <input type="text" className="form-control" name="nomeOSC" onChange={handleChange} value={formData.nomeOSC} />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">CNPJ</label>
                    <input type="text" className="form-control" name="cnpj" onChange={handleChange} value={formData.cnpj} />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Endereço</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">CEP</label>
                    <input type="text" className="form-control" name="cep" onChange={handleChange} value={formData.cep} />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Presidente</label>
                    <input type="text" className="form-control" name="presidente" onChange={handleChange} value={formData.presidente} />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Período de Mandato</label>
                    <input type="text" className="form-control" name="periodoMandato" onChange={handleChange} value={formData.periodoMandato} />
                  </div>
                </div>

                {/* Responsável pela Entidade e Telefone */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Responsável pela Entidade</label>
                    <input type="text" className="form-control" name="responsavelEntidade" onChange={handleChange} value={formData.responsavelEntidade} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input type="text" className="form-control" name="telefone" onChange={handleChange} value={formData.telefone} />
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email" onChange={handleChange} value={formData.email} />
                  </div>
                </div>

                {/* Finalidade da OSC */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Finalidade da OSC</label>
                    <input type="text" className="form-control" name="finalidadeOSC" onChange={handleChange} value={formData.finalidadeOSC} />
                  </div>
                </div>

                {/* Título do Projeto e Endereço do Projeto */}
                <h4 className="mt-4">2. Dados do Projeto</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Título do Projeto</label>
                    <input type="text" className="form-control" name="tituloProjeto" onChange={handleChange} value={formData.tituloProjeto} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Endereço do Projeto</label>
                    <input type="text" className="form-control" name="enderecoProjeto" onChange={handleChange} value={formData.enderecoProjeto} />
                  </div>
                </div>

                {/* Número de Beneficiários e Público-Alvo */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Número de Beneficiários</label>
                    <input type="text" className="form-control" name="numeroBeneficiarios" onChange={handleChange} value={formData.numeroBeneficiarios} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Público-Alvo</label>
                    <input type="text" className="form-control" name="publicoAlvo" onChange={handleChange} value={formData.publicoAlvo} />
                  </div>
                </div>
                
                <h4 className="mt-4">3. Serviço(s) Ofertado(s)</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <textarea placeholder="Descreva os serviços ofertados" type="text" className="form-control" name="servicosOfertados" onChange={handleChange} value={formData.servicosOfertados} />
                  </div>
                </div>

                {/* Horário de Funcionamento, Dias e Atividade no Momento */}
                <h4 className="mt-4">4. Funcionamento e Atividades OSC</h4>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Horário de Funcionamento</label>
                    <input type="text" className="form-control" name="horarioFuncionamento" onChange={handleChange} value={formData.horarioFuncionamento} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Dias de Funcionamento</label>
                    <input type="text" className="form-control" name="diasFuncionamento" onChange={handleChange} value={formData.diasFuncionamento} />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3 form-check">
                    <input type="checkbox" className="form-check-input" name="atividadeNoMomento" onChange={handleChange} checked={formData.atividadeNoMomento} />
                    <label className="form-check-label">OSC desenvolvendo atividade no momento da visita?</label>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Quais atividades estão sendo realizadas?</label>
                    <textarea type="text" className="form-control" name="atividadeNoMomentoDescricao" onChange={handleChange} checked={formData.atividadeNoMomentoDescricao} />
                  </div>
                </div>
                
                {/* Atividades Desenvolvidas */}
                <h4 className="mt-4">5. Atividades Desenvolvidas</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Registro das principais atividades realizadas</label>
                    <textarea className="form-control" rows="3" name="registroPrincipaisAtividades" onChange={handleChange} value={formData.registroPrincipaisAtividades}></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Organização dos cursos ofertados (Só preencher, se houver a existência de cursos)</label>
                    <textarea className="form-control" rows="3" name="registroPrincipaisAtividades" onChange={handleChange} value={formData.registroPrincipaisAtividades}></textarea>
                  </div>
                </div>

                {/* Funcionalidade do Serviço */}
                <h4 className="mt-4">6. Funcionalidade do Serviço</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">A execução do serviço está em conformidade com a lógica da garantia de direitos?</label>
                    <textarea className="form-control" rows="3" name="conformidadeServico" onChange={handleChange} value={formData.conformidadeServico}></textarea>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Qual a meta de atendimento prevista?</label>
                    <textarea className="form-control" rows="3" name="metaAtendimento" onChange={handleChange} value={formData.metaAtendimento}></textarea>
                  </div>
                </div>
                
                {/* Capacidade Instalada */}
                <h4 className="mt-4">7. Capacidade Instalada</h4>
                <div className="col-md-12">
                <div className="mb-3">
                    <h4 className="mt-4">Espaço Físico</h4>
                    <label className="form-label">Organização</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="organizacaoEspacoFisicoAdequado"
                        className="btn-check"
                        name="organizacaoEspacoFisico"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.organizacaoEspacoFisico === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="organizacaoEspacoFisicoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="organizacaoEspacoFisicoParcial"
                        className="btn-check"
                        name="organizacaoEspacoFisico"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.organizacaoEspacoFisico === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="organizacaoEspacoFisicoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="organizacaoEspacoFisicoInadequado"
                        className="btn-check"
                        name="organizacaoEspacoFisico"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.organizacaoEspacoFisico === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="organizacaoEspacoFisicoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Limpeza</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="limpezaEspacoFisicoAdequado"
                        className="btn-check"
                        name="limpezaEspacoFisico"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.limpezaEspacoFisico === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="limpezaEspacoFisicoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="limpezaEspacoFisicoParcial"
                        className="btn-check"
                        name="limpezaEspacoFisico"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.limpezaEspacoFisico === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="limpezaEspacoFisicoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="limpezaEspacoFisicoInadequado"
                        className="btn-check"
                        name="limpezaEspacoFisico"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.limpezaEspacoFisico === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="limpezaEspacoFisicoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Conservação</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="conservacaoEspacoFisicoAdequado"
                        className="btn-check"
                        name="conservacaoEspacoFisico"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.conservacaoEspacoFisico === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="conservacaoEspacoFisicoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="conservacaoEspacoFisicoParcial"
                        className="btn-check"
                        name="conservacaoEspacoFisico"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.conservacaoEspacoFisico === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="conservacaoEspacoFisicoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="conservacaoEspacoFisicoInadequado"
                        className="btn-check"
                        name="conservacaoEspacoFisico"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.conservacaoEspacoFisico === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="conservacaoEspacoFisicoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Identificação dos espaços internos</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="identificacaoEspacoFisicoAdequado"
                        className="btn-check"
                        name="identificacaoEspacoFisico"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.identificacaoEspacoFisico === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="identificacaoEspacoFisicoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="identificacaoEspacoFisicoParcial"
                        className="btn-check"
                        name="identificacaoEspacoFisico"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.identificacaoEspacoFisico === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="identificacaoEspacoFisicoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="identificacaoEspacoFisicoInadequado"
                        className="btn-check"
                        name="identificacaoEspacoFisico"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.identificacaoEspacoFisico === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="identificacaoEspacoFisicoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                </div>

                <div className="col-md-12">
                <div className="mb-3">
                    <h4 className="mt-4">Acessibilidade para pessoas com deficiência e idosos</h4>
                    <label className="form-label">Banheiros</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="banheirosAcessoAdequado"
                        className="btn-check"
                        name="banheirosAcesso"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.banheirosAcesso === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="banheirosAcessoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="banheirosAcessoParcial"
                        className="btn-check"
                        name="banheirosAcesso"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.banheirosAcesso === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="banheirosAcessoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="banheirosAcessoInadequado"
                        className="btn-check"
                        name="banheirosAcesso"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.banheirosAcesso === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="banheirosAcessoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Rampas</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="rampasAcessoAdequado"
                        className="btn-check"
                        name="rampasAcesso"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.rampasAcesso === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="rampasAcessoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="rampasAcessoParcial"
                        className="btn-check"
                        name="rampasAcesso"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.rampasAcesso === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="rampasAcessoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="rampasAcessoInadequado"
                        className="btn-check"
                        name="rampasAcesso"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.rampasAcesso === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="rampasAcessoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Barras de apoio</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="barrasAcessoAdequado"
                        className="btn-check"
                        name="barrasAcesso"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.barrasAcesso === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="barrasAcessoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="barrasAcessoParcial"
                        className="btn-check"
                        name="barrasAcesso"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.barrasAcesso === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="barrasAcessoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="barrasAcessoInadequado"
                        className="btn-check"
                        name="barrasAcesso"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.barrasAcesso === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="barrasAcessoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Portas</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="portasAcessoAdequado"
                        className="btn-check"
                        name="portasAcesso"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.portasAcesso === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="portasAcessoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="portasAcessoParcial"
                        className="btn-check"
                        name="portasAcesso"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.portasAcesso === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="portasAcessoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="portasAcessoInadequado"
                        className="btn-check"
                        name="portasAcesso"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.portasAcesso === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="portasAcessoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Espaço pode receber adaptação?</label>
                    <div className="btn-group w-100" role="group">
                    <input
                        type="radio"
                        id="adaptaçãoAcessoAdequado"
                        className="btn-check"
                        name="adaptaçãoAcesso"
                        onChange={handleChange}
                        value="Adequado"
                        checked={formData.adaptaçãoAcesso === "Adequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="adaptaçãoAcessoAdequado"
                        type="button"
                    >
                        Adequado
                    </label>

                    <input
                        type="radio"
                        id="adaptaçãoAcessoParcial"
                        className="btn-check"
                        name="adaptaçãoAcesso"
                        onChange={handleChange}
                        value="Parcialmente"
                        checked={formData.adaptaçãoAcesso === "Parcialmente"}
                    />
                    <label
                        className="btn"
                        htmlFor="adaptaçãoAcessoParcial"
                        type="button"
                    >
                        Parcialmente
                    </label>

                    <input
                        type="radio"
                        id="adaptaçãoAcessoInadequado"
                        className="btn-check"
                        name="adaptaçãoAcesso"
                        onChange={handleChange}
                        value="Inadequado"
                        checked={formData.adaptaçãoAcesso === "Inadequado"}
                    />
                    <label
                        className="btn"
                        htmlFor="adaptaçãoAcessoInadequado"
                        type="button"
                    >
                        Inadequado
                    </label>
                    </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Espaço fisico</label>
                    <textarea className="form-control" rows="3" placeholder="Descreva o espaço fisico" name="descEspacoFisico" onChange={handleChange} value={formData.descEspacoFisico}></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Equipamentos em quantidade suficiente</label>
                    <textarea className="form-control" rows="3" placeholder="Descreva os equipamentos" name="equipamentoQTD" onChange={handleChange} value={formData.equipamentoQTD}></textarea>
                  </div>
                </div>
                </div>

                {/* Corpo Técnico */}
                <h4 className="mt-4">8. Corpo Técnico</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Equipe técnica</label>
                    <textarea className="form-control" rows="3" name="equipeTecnica" onChange={handleChange} value={formData.equipeTecnica}></textarea>
                  </div>
                </div>

                {/* Redes e Parcerias */}
                <h4 className="mt-4">9. Redes e Parcerias</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">A OSC tem e/ou teve captação de recursos de outras fontes? Se sim, quais?</label>
                    <textarea className="form-control" rows="3" name="redeParceiras" onChange={handleChange} value={formData.redeParceiras}></textarea>
                  </div>
                </div>

                {/* Recomendações */}
                <h4 className="mt-4">10. Recomendações</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Recomendações prestadas no momento da visita</label>
                    <textarea className="form-control" rows="3" name="recomendacoesVisita" onChange={handleChange} value={formData.recomendacoesVisita}></textarea>
                  </div>
                </div>

                {/* Conclusão e Técnica Responsável */}
                <h4 className="mt-4">11. Conclusão</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Conclusão</label>
                    <textarea className="form-control" rows="3" name="conclusao" onChange={handleChange} value={formData.conclusao}></textarea>
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Técnica Responsável</label>
                    <input type="text" className="form-control" name="tecnicaResponsavel" onChange={handleChange} value={formData.tecnicaResponsavel} />
                  </div>
                
                </div>
                <div className="col-md-4">
                <div className="mb-3">
                    <label className="form-label">Matrícula</label>
                    <input type="text" className="form-control" name="tecnicaResponsavel" onChange={handleChange} value={formData.tecnicaResponsavel} />
                  </div>
                  </div>
              </div>
            </div>
            
            <div className="card-footer text-end">
              <button type="button" className="btn btn-secondary me-2" onClick={() => setFormData({})}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}

export default RelatorioNovo;